import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { RadioGroupField } from '@brighte/form-components';
import { FinancePurchaseType } from '@brighte/validation';
import { FinancialProduct } from '@graphql/index';
import { RadioCard } from '@spark-web/radio';
import { Text } from '@spark-web/text';
import { FINANCE_PURCHASE } from '@utils';
import { financialProductLabel } from './utils';

export function PaymentSelection({
  control,
  setValue,
  resetField,
  financialProduct,
  isCashPaymentEnabled,
}: Pick<UseFormReturn<FinancePurchaseType>, 'setValue' | 'control' | 'resetField'> & {
  financialProduct: FinancialProduct | undefined;
  isCashPaymentEnabled: boolean | undefined;
}) {
  const isCashEnabled = isCashPaymentEnabled ?? false;

  useEffect(() => {
    if (!isCashEnabled) {
      setValue('payment.isCashApplication', false);
    }
  }, []);

  const handleChange = () => {
    resetField('repaymentTerm');
  };

  return (
    <>
      {isCashEnabled ? (
        <RadioGroupField name="payment.isCashApplication" label="" control={control} onChange={handleChange}>
          <RadioCard value={false} description="Custom fixed interest rate">
            <Text>{financialProductLabel(financialProduct)}</Text>
          </RadioCard>
          <RadioCard value={true} description="Pay remaining amount directly to vendor">
            <Text>{FINANCE_PURCHASE.OTHER_PAYMENT_METHODS}</Text>
          </RadioCard>
        </RadioGroupField>
      ) : null}
    </>
  );
}
